import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable, PLATFORM_ID, inject } from "@angular/core";
import { Observable } from "rxjs";
import { MasterService } from "./common/master.service";
import { BaseUrlEnum, getBaseURL } from "./common/base-url-resolver.util";

@Injectable({
  providedIn: "root",
})
export class CategoryService {
  private http = inject(HttpClient);
  private masterService = inject(MasterService);
  private platformId = inject<Object>(PLATFORM_ID);

  // getCategories(payload?: Params): Observable<ICategoryModel> {
  //   return this.http.get<ICategoryModel>(`${environment.URL}/category.json`, {
  //     params: payload,
  //   });
  // }

  getAll(): Observable<any> {
    return this.masterService.get<any>(
      getBaseURL(this.platformId, BaseUrlEnum.Inventory),
      `ecommerce/category/Last-Layer-Categories`
    );
  }
  LayerdCategoriesWithProducts(): Observable<any> {
    return this.masterService.get<any>(
      getBaseURL(this.platformId, BaseUrlEnum.Inventory),
      `ecommerce/category/Layerd-Categories-With-Products`
    );
  }
    ProductsWithCategoriesSlug(slug: string, context?: HttpContext): Observable<any> {
    return this.masterService.getCached<any>(
      `category-products-${slug}`,
      getBaseURL(this.platformId, BaseUrlEnum.Inventory),
      `ecommerce/product/sub-category-products-by-slug/${slug}?page=1&pageSize=50`,
      context
    );
  }

  getCategoryDetailsBySlug(slug: string): Observable<any> {
    return this.masterService.getCached<any>(
      `category-details-${slug}`,
      getBaseURL(this.platformId, BaseUrlEnum.Inventory),
      `ecommerce/category/category-details-by-slug?slug=${encodeURIComponent(slug)}`
    );
  }
  //have to change this
}
